(() => {
  const SLIDE_MS = 1800;
  const MODE = { ANIMATION: 'animation', EXAMPLE: 'example', QUANTITY: 'quantity' };

  function init(section) {
    const hero = section.querySelector('.pocket-hero-media');
    const layers = [...section.querySelectorAll('[data-hero-layer]')];
    const select = section.querySelector('[data-pack]');
    const thumbs = [...section.querySelectorAll('[data-example-thumb]')];
    if (!hero || layers.length < 2 || !select || hero.dataset.mediaReady) return;

    hero.dataset.mediaReady = 'true';
    const slides = [...hero.querySelectorAll('[data-product-slide]')].map(node => node.dataset.productSlide).filter(Boolean);
    let mode = MODE.ANIMATION;
    let activeLayer = 0;
    let slideIndex = 0;
    let timer = null;
    let swapToken = 0;

    function setActiveThumb(activeThumb = null) {
      thumbs.forEach(thumb => {
        const active = thumb === activeThumb;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function swap(src, alt, fitMode) {
      if (!src) return;
      hero.classList.toggle('is-quantity', fitMode === MODE.QUANTITY);
      const token = ++swapToken;
      const nextLayer = activeLayer === 0 ? 1 : 0;
      const incoming = layers[nextLayer];
      const outgoing = layers[activeLayer];
      incoming.classList.remove('is-active');
      incoming.removeAttribute('srcset');
      incoming.removeAttribute('sizes');
      incoming.alt = alt || '';
      incoming.setAttribute('aria-hidden', alt ? 'false' : 'true');
      const reveal = () => {
        if (token !== swapToken) return;
        requestAnimationFrame(() => {
          incoming.classList.add('is-active');
          outgoing.classList.remove('is-active');
          outgoing.setAttribute('aria-hidden', 'true');
          activeLayer = nextLayer;
        });
      };
      incoming.onload = reveal;
      incoming.onerror = () => {};
      incoming.src = src;
      if (incoming.complete && incoming.naturalWidth) reveal();
    }

    function stopAnimation() {
      if (timer) clearInterval(timer);
      timer = null;
    }

    function currentArtworkPack() {
      const option = select.options[select.selectedIndex];
      if (!option) return null;
      // Numeric pack controls have no data-title. Finish-suffixed variant titles still parse via packSize.
      const label = option.dataset.title || option.textContent || '';
      return window.PocketCore?.quantityMediaPack(label);
    }

    function showQuantity() {
      const pack = currentArtworkPack();
      if (pack == null) return;
      const src = hero.dataset[`packImage${pack}`];
      if (!src) return;
      mode = MODE.QUANTITY;
      stopAnimation();
      setActiveThumb();
      swap(src, `${pack} Pocket Factory NFC ${pack === 1 ? 'card' : 'cards'} quantity preview`, MODE.QUANTITY);
    }

    function showExample(thumb) {
      const src = thumb.dataset.src;
      if (!src) return;
      mode = MODE.EXAMPLE;
      stopAnimation();
      setActiveThumb(thumb);
      swap(src, thumb.getAttribute('aria-label') || 'Pocket Factory card personalization example', MODE.EXAMPLE);
    }

    function startAnimation() {
      if (!slides.length || mode !== MODE.ANIMATION || timer || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      setActiveThumb();
      slides.slice(1).forEach(src => { const preload = new Image(); preload.src = src; });
      timer = setInterval(() => {
        if (mode !== MODE.ANIMATION) return stopAnimation();
        slideIndex = (slideIndex + 1) % slides.length;
        swap(slides[slideIndex], 'Pocket Factory personalized NFC card design example', MODE.ANIMATION);
      }, SLIDE_MS);
    }

    thumbs.forEach(thumb => thumb.addEventListener('click', () => showExample(thumb)));
    select.addEventListener('change', showQuantity);
    section.querySelectorAll('[data-pack-step]').forEach(button => button.addEventListener('click', () => queueMicrotask(showQuantity)));
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stopAnimation();
      else if (mode === MODE.ANIMATION) startAnimation();
    });
    startAnimation();
  }

  document.querySelectorAll('[data-pocket-product]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll?.('[data-pocket-product]').forEach(init));
})();

